module.exports = __webpack_public_path__ + "static/image2-d0e558aa58ce7650d16e84eabfdcaba1.png";